import { useCreatePortfolio } from './CreatePortfolioManager';

export const useCreatePortfolioActions = () => {
    const { actions } = useCreatePortfolio();

    return actions;
};
